import { $Locale } from '@lemon8/web-app-shared/atom';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { WebSite, WithContext } from 'schema-dts';

const APP_NAME = 'Lemon8';
const DOMAIN_NAME = 'https://www.lemon8-app.com';

export const WebSiteJSONLD: FC = (props) => {
  const { region } = useAtomValue($Locale);

  const { t } = useTranslation();

  const jsonLD: WithContext<WebSite> = {
    '@context': 'https://schema.org',
    '@id': `${DOMAIN_NAME}/feed/foryou?region=${region}`,
    '@type': 'WebSite',
    description: t('category_recommend_desc'),
    name: APP_NAME,
    url: `${DOMAIN_NAME}/`,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `https://www.lemon8-app.com/search/{search_term_string}?region=${region}`,
      },
      'query-input': 'required name=search_term_string',
    } as any,
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }} />;
};
